<template src="./AppSidebar.html" />

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fas);

export default {
  name: 'AppSidebar',
  components: {
    FontAwesomeIcon
  },
  setup() {
    const isSidebarOpen = ref(false);
    const router = useRouter();

    const toggleSidebar = () => {
      isSidebarOpen.value = !isSidebarOpen.value;
    };

    const openSidebar = () => {
      isSidebarOpen.value = true;
    };

    const closeSidebar = () => {
      isSidebarOpen.value = false;
    };

    const onLogOut = () => {
      localStorage.removeItem('token');
      router.push('/login');
    };

    const menuItems = [
      { path: '/galleria-foto', icon: ['fas', 'camera'], text: 'Foto' },
      { path: '/galleria-video', icon: ['fas', 'video'], text: 'Video' },
      { path: '/pagina-news', icon: ['fas', 'newspaper'], text: 'News' },
      { path: '/pagina-coltelli', icon: ['fas', 'feather'], text: 'Coltelli' }

    ];

    return { isSidebarOpen, toggleSidebar, openSidebar, closeSidebar, onLogOut, menuItems };
  }
};
</script>

<style scoped></style>